import { ContainerModule } from 'inversify';
import DITypes from './types';
import type {
  IDispatcherFactory,
  IDispatcherFactoryMethod,
  IAdapterCache,
  IAdapterFactory,
  IDispatcherCache,
} from './interfaces';
import { DispatcherFactory } from '../DispatcherFactory';
import DispatcherCache from '../cache/DispatcherCache';
import AdapterCache from '../cache/AdapterCache';
import { DataroomTenant } from '@dataroom/tenant/DataroomTenant';
import AdapterFactory from '@framework/di/Providers/Rpc/AdapterFactory';

export const DispatcherModule = new ContainerModule(({ bind }) => {
  bind<IDispatcherCache>(DITypes.DispatcherCache).to(DispatcherCache).inSingletonScope();

  bind<IAdapterCache>(DITypes.AdapterCache).to(AdapterCache).inSingletonScope();

  bind<IAdapterFactory>(DITypes.AdapterFactory).to(AdapterFactory).inSingletonScope();

  bind<IDispatcherFactory>(DITypes.JsonRpcDispatcherFactory).to(DispatcherFactory).inSingletonScope();

  bind<IDispatcherFactoryMethod>(DITypes.JsonRpcDispatcher).toFactory(({ get }) =>
    (tenant?: DataroomTenant) => get<IDispatcherFactory>(DITypes.JsonRpcDispatcherFactory).create(tenant),
  );
});
